// Translations
import tosDialog from '../components/tos-dialog/translations/ar'

// Translation: Register > Landing > Form (Arabic)
export default Object.freeze({
	components: { tosDialog },
	form: {
		actions: {
			continue: 'إستمرار',
			register: 'إنشاء حساب'
		},
		fields: {
			email: {
				placeholder: 'أدخل عنوان البريد الإلكتروني'
			},
			firstName: {
				placeholder: 'أدخل الاسم'
			},
			lastName: {
				placeholder: 'أدخل الكنية'
			},
			password: {
				placeholder: 'أدخل كلمة المرور'
			},
			passwordConfirmation: {
				placeholder: 'تأكيد كلمة المرور'
			}
		},
		options: {
			login: {
				action: 'تسجيل الدخول',
				label: 'هل تملك حساب؟'
			}
		},
		title: {
			accountInformation: 'معلومات الحساب',
			profileDetails: 'تفاصيل الملف الشخصي'
		}
	}
})
